//https://hannahgoodridge.dev/playground/circular-draggable-audio-player/
import React from "react";
import {
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  CardContent,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import AudioPlayer from "../../AudioPlayer";
import { API_DOMAIN } from "../../../constants";
import { styled } from "@mui/material/styles";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { red } from "@mui/material/colors";
//const API_DOMAIN = "https://capacitamos.com/online"

const CenteredWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  margin: "10px",
});

const ImageWrapper = styled("div")(({ isSelected }) => ({
  width: "100%",
  maxWidth: "150px",
  height: "auto",
  borderRadius: "8px",
  overflow: "hidden",
  transition: "transform 0.3s, border 0.3s",
  border: isSelected ? "4px solid #005375" : "4px solid transparent",
  boxSizing: "border-box",
  "&:hover": {
    transform: "scale(1.05)",
  },
}));

const StyledImage = styled("img")({
  width: "100%",
  height: "auto",
  display: "block",
});

const ListenAndSelectImage = ({
  question,
  selectedAnswer,
  showCorrect,
  showInCorrect,
  showPhare,
  setAnswer,
  courseCode
}) => {
  const handleAnswerChange = (event) => {
    if (!showCorrect && !showInCorrect) {
      setAnswer(event.target.value);
    }
  };
  return (
    <Grid container columns={{ xs: 4, md: 12 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "space-around" }}>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: -8,
                  flexDirection: "column",
                }}
              >
                <Stack direction="row" spacing={1}>
                  <AudioPlayer
                    audioUrl={`${API_DOMAIN}/contents/cursos/${courseCode}/audios/${question.audio}`}
                    key={question.audio}
                  />
                </Stack>
                {showPhare ? (
                  <Typography
                  variant="subtitle1"
                  align="center"
                  color={"primary"}
                  sx={{ fontWeight: "bold" }}
                >
                  {question.frase}
                </Typography>
                ):null}
                
              </Box>
            </Box>
          </Box>
          <Grid item xs={12} style={{ display: "flex", marginBottom: 15 }}>
            <RadioGroup
              value={selectedAnswer}
              onChange={handleAnswerChange}
              style={{
                width: "100%",
                justifyContent: "center",
                display: "contents",
              }}
              row
            >
              {question.options.map((option) => (
                <CenteredWrapper key={option.value}>
                  <ImageWrapper
                    isSelected={
                      selectedAnswer === `${option.id}-${option.respuesta}`
                    }
                  >
                    <StyledImage
                      src={`${API_DOMAIN}/contents/cursos/${courseCode}/img/${option.opcion}`}
                    />
                  </ImageWrapper>
                  <FormControlLabel
                    key={`${option.id}-${option.respuesta}`}
                    value={`${option.id}-${option.respuesta}`}
                    control={
                      showCorrect && option.respuesta == 1 ? (
                        <CheckCircle color="success" />
                      ) : showInCorrect &&
                        option.respuesta == 0 &&
                        selectedAnswer == `${option.id}-${option.respuesta}` ? (
                        <CancelIcon sx={{ color: red[500] }} />
                      ) : (
                        <Radio />
                      )
                    }
                  />
                </CenteredWrapper>
              ))}
            </RadioGroup>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ListenAndSelectImage;
